import React from 'react';
import Table from '../components/Table';

  export default function UserDevicesIndexPage({ data }) {
    const columns = React.useMemo(
      () => [
        {
          accessorFn: (row) => row.id.toString() || '',
          header: 'Database ID',
        },
        {
          accessorFn: (row) => `${row.user?.first_name || ''} ${row.user?.last_name || ''}`.trim(),
          header: 'User Name',
        },
        {
          accessorKey: 'device_id',
          header: 'Device ID',
        },
        {
          accessorKey: 'os',
          header: 'OS',
        },
                {
          accessorKey: 'os_version',
          header: 'OS Version',
        },
        {
          accessorKey: 'app_version',
          header: 'App Version',
        },
        {
          accessorKey: 'unique_id',
          header: 'Unique ID',
        },
      ],
    [],
  )

  return (
    <div>
      <h1>User Devices Index Page</h1>
      <Table columns={columns} data={data} />
    </div>

  );
}